var map = {
	"./icon-bg-stripe.png": 592,
	"./wdg-add-custom.png": 593,
	"./wdg-add-image.png": 594,
	"./wdg-add-slider.png": 595,
	"./wdg-add-video.png": 596,
	"./wdg-bg-image.png": 597,
	"./wdg-bg-video.png": 598,
	"./wdg-bg-zip.png": 599,
	"./wdg-big-bg-custom.png": 600,
	"./wdg-big-bg-poll.png": 601,
	"./wdg-big-bg-video.png": 602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;